import { render, staticRenderFns } from "./DocumentsShow.vue?vue&type=template&id=c2934eee&scoped=true&"
import script from "./DocumentsShow.vue?vue&type=script&lang=js&"
export * from "./DocumentsShow.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsShow.vue?vue&type=style&index=0&id=c2934eee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2934eee",
  null
  
)

export default component.exports